module.exports = __webpack_public_path__ + "assets/img/11.a03dac01.jpg";